import { MessageGenerationStateContainer } from './MessageGenerationState.Container';
import { MessageGenerationWebSocketContainer } from './MessageGenerationWebSocket.Container';

export const MessageGenerationContainer = ({
  children,
}: {
  children: React.JSX.Element;
}): React.JSX.Element => {
  return (
    <MessageGenerationStateContainer>
      <MessageGenerationWebSocketContainer>{children}</MessageGenerationWebSocketContainer>
    </MessageGenerationStateContainer>
  );
};
